import { FC, ReactNode } from "react";
import { AlertIcon, ArchiveIcon, SnowflakeIcon } from "../../icons";
import { cn } from "../../utils/class-names";
import { isNotNullable } from "effect/Predicate";

interface AlertChipProps {
  icon: ReactNode;
  label?: string;
  className?: string;
}

export const AlertChip: FC<AlertChipProps> = ({ icon, label, className }) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2.5 rounded-full bg-shale-750 px-2.5 py-1.5 w-fit text-white",
        className
      )}
    >
      <span>{icon}</span>

      {isNotNullable(label) && (
        <span className="font-sans text-sm font-normal whitespace-nowrap">
          {label}
        </span>
      )}
    </div>
  );
};

interface DeprecatedChipProps {
  className?: string;
  iconOnly?: boolean;
}

export function DeprecatedChip({
  className,
  iconOnly = false,
}: DeprecatedChipProps): JSX.Element {
  return (
    <AlertChip
      className={className}
      icon={<ArchiveIcon className="w-4 h-4" />}
      label={iconOnly ? undefined : "Deprecated"}
    />
  );
}

interface UnstableOracleChipProps {
  className?: string;
  iconOnly?: boolean;
}

export function UnstableOracleChip({
  className,
  iconOnly = false,
}: UnstableOracleChipProps): JSX.Element {
  return (
    <AlertChip
      className={className}
      icon={<AlertIcon className="w-4 h-4" />}
      label={iconOnly ? undefined : "Oracle risk"}
    />
  );
}

interface PausedChipProps {
  className?: string;
  iconOnly?: boolean;
}

export function PausedChip({
  className,
  iconOnly = false,
}: PausedChipProps): JSX.Element {
  return (
    <AlertChip
      className={className}
      icon={<SnowflakeIcon className="w-4 h-4" />}
      label={iconOnly ? undefined : "Frozen"}
    />
  );
}

interface AtRiskOfLiquidationChipProps {
  className?: string;
}

export function AtRiskOfLiquidationChip({
  className,
}: AtRiskOfLiquidationChipProps): JSX.Element {
  return (
    <AlertChip
      className={className}
      icon={<AlertIcon className="w-4 h-4" />}
      label="At risk of liquidation"
    />
  );
}
